module.exports = __webpack_public_path__ + "img/cargo-wagon-door-horizontal-top-mask.f09aac55.png";